import React from 'react';
import CardGranularStep from '../GSCard';
import LearningContinuumCards from './LCCards';

const LGRow = ({
  lcs = [],
  completed,
  currentCurriculum,
  learningGrowth = [],
  loadingLearningGrowth,
  classUlInfo,
  direction = 'row',
  top = '0px'
}) => {
  const minMarking = currentCurriculum?.marking?.find((item) => item.minValue) || {};

  const lcsElements = {};
  let levelsId = [];
  lcs.forEach((lc) => {
    lcsElements[lc._id] = currentCurriculum.elements;
    const lvls = lc.granularSteps?.filter((step) => step.definition).map((step) => step.levelId);
    levelsId = [...levelsId, ...lvls];
  });

  levelsId = [...new Set(levelsId)];
  const levelsRender = currentCurriculum?.levels
    ?.filter((item) => levelsId.includes(item._id))
    .sort((a, b) => (direction === 'row' ? a.position - b.position : b.position - a.position));
  const size = 35;

  return (
    <div
      className={[
        'py-1 flex gap-1',
        lcs.length > 3 ? 'w-fit' : 'w-auto',
        direction === 'row' ? 'w-fit' : 'flex-col '
      ].join(' ')}
    >
      {direction === 'row' && (
        <LearningContinuumCards
          classUlInfo={classUlInfo}
          size={size}
          currentCurriculum={currentCurriculum}
          lcs={lcs || []}
          direction={direction}
          top={top}
        />
      )}
      {levelsRender?.map((item, index) => (
        <React.Fragment key={`granular-steps-level-${item._id}`}>
          <CardGranularStep
            completed={completed}
            lcs={lcs}
            levelId={item._id}
            level={{
              ...item,
              primaryColor: minMarking?.primaryColor,
              secondaryColor: minMarking?.secondaryColor,
              levelIndex: index
            }}
            nextLevel={direction === 'row' ? levelsRender[index + 1] : levelsRender[index - 1]}
            learningGrowth={learningGrowth}
            loadingLearningGrowth={loadingLearningGrowth}
            size={size}
            currentCurriculum={currentCurriculum}
            direction={direction}
            top={top}
          />
        </React.Fragment>
      ))}
      {direction === 'column' && (
        <LearningContinuumCards
          classUlInfo={classUlInfo}
          size={size}
          currentCurriculum={currentCurriculum}
          lcs={lcs || []}
          direction={direction}
          top={top}
        />
      )}
    </div>
  );
};

export default LGRow;
